"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBrowserApolloClient;

var _apolloClient = _interopRequireDefault(require("apollo-client"));

var _apolloLinkBatchHttp = require("apollo-link-batch-http");

var _apolloCacheInmemory = require("apollo-cache-inmemory");

var _apolloLink = require("apollo-link");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var DEFAULT_TARGET_PATH = 'default';
var DEFAULT_LINK_OPTIONS = {
  credentials: 'include',
  batchInterval: 30
};

function createBrowserApolloClient(_ref) {
  var fragmentMatcherFn = _ref.fragmentMatcherFn,
      metadata = _ref.metadata,
      pageRequestId = _ref.pageRequestId,
      _ref$cacheHydration = _ref.cacheHydration,
      cacheHydration = _ref$cacheHydration === void 0 ? {} : _ref$cacheHydration,
      _ref$uri = _ref.uri,
      uri = _ref$uri === void 0 ? '/graphql' : _ref$uri,
      _ref$linkOptions = _ref.linkOptions,
      linkOptions = _ref$linkOptions === void 0 ? {} : _ref$linkOptions,
      _ref$devToolsEnabled = _ref.devToolsEnabled,
      devToolsEnabled = _ref$devToolsEnabled === void 0 ? true : _ref$devToolsEnabled,
      _ref$availableLoggedO = _ref.availableLoggedOutPaths,
      availableLoggedOutPaths = _ref$availableLoggedO === void 0 ? [] : _ref$availableLoggedO,
      authLink = _ref.authLink;
  var appName = metadata.appName,
      appVersion = metadata.appVersion;
  var cache = new _apolloCacheInmemory.InMemoryCache({
    fragmentMatcher: fragmentMatcherFn && fragmentMatcherFn()
  }).restore(cacheHydration);

  var _linkOptions$headers = linkOptions.headers,
      headers = _linkOptions$headers === void 0 ? {} : _linkOptions$headers,
      otherLinkOptions = _objectWithoutProperties(linkOptions, ["headers"]);

  if (pageRequestId) {
    headers['sm-page-request-id'] = pageRequestId;
  }

  var apolloLinkMemoizeCache = {};

  function apolloLinkFactory() {
    var targetPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TARGET_PATH;

    if (apolloLinkMemoizeCache[targetPath]) {
      return apolloLinkMemoizeCache[targetPath];
    }

    var link = new _apolloLinkBatchHttp.BatchHttpLink(_objectSpread({}, DEFAULT_LINK_OPTIONS, {}, otherLinkOptions, {
      uri: targetPath,
      headers: headers
    }));

    if (authLink && targetPath === '/graphql') {
      link = authLink.concat(link);
    }

    apolloLinkMemoizeCache[targetPath] = link;
    return link;
  } // custom apollo-link that determines the actual link to use based on the passed
  // `targetPath` context.


  var link = new _apolloLink.ApolloLink(function (operation) {
    var _operation$getContext, _operation$getContext2; // if the targetPath is not the default, use an alternate graphql endpoint.


    var targetPath = operation === null || operation === void 0 ? void 0 : (_operation$getContext = operation.getContext) === null || _operation$getContext === void 0 ? void 0 : (_operation$getContext2 = _operation$getContext.call(operation)) === null || _operation$getContext2 === void 0 ? void 0 : _operation$getContext2.targetPath;
    var graphQLPath = uri;

    if (availableLoggedOutPaths.includes(targetPath)) {
      // whitelist for security
      graphQLPath = targetPath;
    }

    return apolloLinkFactory(graphQLPath).request(operation) || _apolloLink.Observable.of();
  });
  return new _apolloClient.default({
    connectToDevTools: devToolsEnabled,
    cache: cache,
    link: link,
    name: appName,
    version: appVersion
  });
}

module.exports = exports.default;